module.exports = __webpack_public_path__ + "img/oval.79e86acc.svg";